import {Doctor} from '../../../mdqx-graphql-types';
import { isNotNullOrUndefined } from '../../../../helper/helper';

export class DoctorEntity {
    public static readonly GqlFields: Array<keyof Doctor> = ['customerIds', 'id', 'isActive', 'lanr', 'name', 'schwerpunkt', 'qualificationIds', 'email', 'membershipIds', 'typeoftreatmentsIds', 'doctorCatalogIds', 'serviceGroupIds'];

    public CustomerIds: number[];
    public Id: number;
    public IsActive?: boolean | null;
    public Lanr?: string | null;
    public Name?: string | null;
    public Schwerpunkt?: string | null;
    public Email?: string | null;
    public DoctorTypeId?: number | null;
    public MembershipIds?: number[];
    public TypeOfTreatmentIds?: number[];
    public QualificationIds?: number[];
    public DoctorCatalogIds?: number[];
    public ServiceGroupIds?: number[];

    constructor(doctorType?: Doctor | null) {
        if (
            doctorType &&
            // doctorType.customerIds?.length > 0 && todo check wieder einbauen
            doctorType.id != null &&
            doctorType.isActive !== undefined &&
            doctorType.lanr !== undefined &&
            doctorType.name !== undefined &&
            doctorType.email !== undefined &&
            isNotNullOrUndefined(doctorType.membershipIds) &&
            isNotNullOrUndefined(doctorType.typeoftreatmentsIds) &&
            isNotNullOrUndefined(doctorType.qualificationIds) &&
            isNotNullOrUndefined(doctorType.doctorCatalogIds) &&
            isNotNullOrUndefined(doctorType.serviceGroupIds)
        ) {
            this.CustomerIds = doctorType.customerIds;
            this.Id = doctorType.id;
            this.IsActive = doctorType.isActive;
            this.Lanr = doctorType.lanr;
            this.Name = doctorType.name;
            this.Schwerpunkt = doctorType.schwerpunkt;
            this.Email = doctorType.email;
            this.MembershipIds = doctorType.membershipIds;
            this.TypeOfTreatmentIds = doctorType.typeoftreatmentsIds;
            this.QualificationIds = doctorType.qualificationIds;
            this.DoctorCatalogIds = doctorType.doctorCatalogIds;
            this.ServiceGroupIds = doctorType.serviceGroupIds;
        } else {
            console.error('Received broken DoctorType', doctorType);
            throw Error();
        }
    }
    get DisplayName() {
        return this.Name || '';
    }
}
